// routes/PrivateRoute.js -- REPLACEMENT CODE

import React, { useEffect } from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { checkUserSession } from '../redux/actions/authActions';
import { ROUTES } from '../config/constants';

const LoadingScreen = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    Loading session...
  </div>
);

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { isAuthenticated, isLoading } = useSelector(state => state.auth);

  useEffect(() => {
    dispatch(checkUserSession());
  }, [dispatch, location.pathname]);
  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;